export default "__VITE_ASSET__935650e4__"